// PRODUCCION LINKS

export const BaseUrlAuth = "https://ws.arsrenacer.com:443/autorizaciones/v1/autorizaciones";
export const BaseUrlInfo = "https://ws.arsrenacer.com:443/autorizaciones/v1/informacion";
export const BaseUrlServ = "https://webapiauthprd.arsrenacer.com/Servicios";
export const BaseUrlQuejas = "https://vobackrena.arsrenacer.com/Afiliado";
export const BaseUrlEncuesta = "https://webapiauthprd.arsrenacer.com/Servicios"

// QA LINKS
/*
export const BaseUrlAuth = "https://pruebas-ws.arsrenacer.com:443/autorizaciones/v1/autorizaciones";
export const BaseUrlInfo = "https://pruebas-ws.arsrenacer.com:443/autorizaciones/v1/informacion";
export const BaseUrlServ = "https://webapiauthqa.arsrenacer.com/Servicios";
export const BaseUrlQuejas = "https://vobackrena.arsrenacer.com/Afiliado";
export const BaseUrlEncuesta = "https://webapiauthqa.arsrenacer.com/Servicios"
*/

